import NonReferableIcon from '../../../../assets/icons/non-referable-icon.svg'
import ReferableIcon from '../../../../assets/icons/referable-icon.svg'

export const STATUS_INFO = {
  referable: {
    icon: ReferableIcon,
    title: 'Referible',
    subtitle1: 'Nuestra IA observa lesiones compatibles con la retinopatía diabética en este examen.',
    subtitle2: ' Se recomienda informe profesional para confirmar el diagnóstico.',
    button1: 'Descargar',
    button2: 'Finalizar sin derivar',
    button3: 'Derivar a oftalmólogo'
  },
  nonReferable: {
    icon: NonReferableIcon,
    title: 'No referible',
    subtitle1: 'Nuestra IA no observa lesiones compatibles con la retinopatía diabética al momento de este examen.',
    subtitle2: 'No obstante, la imagen debería ser informada por un profesional para confirmar el diagnóstico.',
    button1: 'Descargar',
    button2: 'Derivar a oftalmólogo',
    button3: 'Finalizar'
  },
  nonReferableSampled: {
    icon: NonReferableIcon,
    title: 'No referible',
    subtitle1: 'Nuestra IA no observa lesiones compatibles con la retinopatía diabética al momento de este examen.',
    subtitle2: 'No obstante, este estudio ha sido seleccionado por nuestro sistema de muestreo para control de calidad y revisión oftalmológica obligatoria.',
    button1: 'Descargar',
    button2: null,
    button3: 'Derivar por control de calidad'
  }
}

export const FINAL_CASES = [
  'referable_referred',
  'referable_not_referred',
  'nonreferable_referred',
  'nonreferable_not_referred',
  'nonreferable_sampled'
]
